import ProductType from "@/models/Products/ProductType";

export default (val: ProductType) => {
    let returnVal = "Undefined";
    switch (val) {
        case ProductType.Deposit:
            returnVal = "Deposit"
            break;
        case ProductType.Lending:
            returnVal = "Lending"
            break;
    }
    return returnVal;
}